module.exports = __webpack_public_path__ + "img/onassis-inline-black.8c400df2.svg";